module.exports = __webpack_public_path__ + "static/stateSign.3ca65ea5.png";